import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { GlassCard, LoadingOverlay } from '../../components';
import { getActiveAnnouncements } from '../../services/firestoreService';
import { formatDateTime } from '../../utils/helpers';
import './NotificationsScreen.css';

export const NotificationsScreen = () => {
    const navigate = useNavigate();
    const [announcements, setAnnouncements] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        loadAnnouncements();
    }, []);

    const loadAnnouncements = async () => {
        try {
            const data = await getActiveAnnouncements();
            setAnnouncements(data);
        } catch (error) {
            console.error('Error loading announcements:', error);
        } finally {
            setLoading(false);
        }
    };

    if (loading) {
        return <LoadingOverlay visible message="Loading notifications..." />;
    }

    return (
        <div className="notifications-screen">
            <div className="screen-header">
                <button className="back-btn" onClick={() => navigate(-1)}>
                    <span className="material-icons">arrow_back</span>
                </button>
                <h1 className="screen-title">Notifications</h1>
                <div style={{ width: 40 }}></div>
            </div>

            {announcements.length > 0 ? (
                <div className="notifications-list">
                    {announcements.map((announcement) => (
                        <GlassCard key={announcement.id} className="notification-card">
                            <div className="notification-icon">
                                <span className="material-icons">campaign</span>
                            </div>
                            <div className="notification-content">
                                <h4 className="notification-title">{announcement.title}</h4>
                                <p className="notification-message">{announcement.message}</p>
                                <span className="notification-time">
                                    {formatDateTime(announcement.createdAt)}
                                </span>
                            </div>
                        </GlassCard>
                    ))}
                </div>
            ) : (
                <div className="empty-state">
                    <span className="material-icons empty-icon">notifications_off</span>
                    <h3>No Notifications</h3>
                    <p>You're all caught up! Check back later for updates.</p>
                </div>
            )}
        </div>
    );
};

export default NotificationsScreen;
